export default __webpack_public_path__ + "static/media/delete.90305936.svg";